/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Manage_Plan_CanceledInputs */



/**
* | output |
* | --- |
* | "Scheduled downgrade canceled." |
*
* @param {Partner_Manage_Plan_CanceledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_manage_plan_canceled = /** @type {((inputs?: Partner_Manage_Plan_CanceledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Manage_Plan_CanceledInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Geplantes Downgrade abgebrochen.")
	return /** @type {LocalizedString} */ ("Scheduled downgrade canceled.")
});